import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";

let cached = null;

export function useCityGroups() {
  const [groups, setGroups] = useState(cached || []);
  useEffect(() => {
    if (cached) { return; }
    api.get("/cities").then((r) => { cached = r.data; setGroups(r.data); }).catch(() => {});
  }, []);
  return groups;
}

export function CityDatalist({ id = "city-options" }) {
  const groups = useCityGroups();
  return (
    <datalist id={id}>
      {groups.flatMap((g) => g.cities.map((c) => <option key={`${g.region}-${c}`} value={c}>{g.region}</option>))}
    </datalist>
  );
}
